<template>
    <div class="wrapper" style="height:400px;width:100%;">
      <div class="row">
        <div class="col-md">
          <div role="toolbar" class="btn-toolbar justify-content-between mb-2">
            <button @click="save()" class="btn btn-primary"><font-awesome-icon icon="save"/>&nbsp;Speichern</button>
            <div class="input-group ml-3">
              <input type="text" placeholder="Inventur-ID" class="form-control" v-model="testid"/>
              <div class="input-group-append">
                <button @click="testRule" class="btn btn-secondary"><font-awesome-icon icon="vial"/></button>
              </div>
            </div>
          </div>
          <AceEditor ref="editor" :editorId='"invCheckEdit"' :lang="'javascript'" :content="script"/>
        </div>
        <div class="col-md">
          <iframe style="width:100%;height:500px;border: none;" :src="baseurl + 'help/scriptrules/orderprework.html'">
          </iframe>
        </div>
      </div>
      <b-modal id="invCheckResult" size="xl" title="Test-Ergebniss" ok-only>
        <JsonViewer :data="testresult"/>
      </b-modal>
    </div>
  </template>
  
  <script>
  import config from '@/modules/config.js'
  import rules from '@/modules/rules.js'
  import AceEditor from '@/components/AceEditor.vue'
  import JsonViewer from '@/components/JsonViewer.vue'
  
  export default {
    name: 'RuleInventoryCheck',
    components: {
      AceEditor,
      JsonViewer,
    },
    data() {
      return {
        baseurl: config.baseUrl,
        script: "",
        testid: '',
        testresult: {},
      }
    },
    created: function() {
      var self = this;
      rules.load('inventoryPreWork',function(data) {
        if (data) self.script = data.script;
      });
    },
    methods: {
      testRule: function() {
        console.log('test');
        if (this.testid == '')  {
          this.$bvToast.toast('Bitte zuerst eine Inventurnummer als Beispiel eingeben.',{title:'Inventurprüfung',variant:'warning'})
          return;
        }
        var self = this;
        rules.testinventorycheck(this,this.testid,{script: this.$refs.editor.getContent()},function(data){
          console.log(data);
          self.testresult = data;
          self.$bvModal.show('invCheckResult');
        })
      },
      save: function() {
        this.script = this.$refs.editor.getContent();
        var update = {ruleId: 'inventoryPreWork',script: this.script};
        var self = this;
        rules.save(update,function() {
          self.$bvToast.toast(`Regel gespeichert`, { title: 'Inventurprüfung', autoHideDelay: 2000, appendToast: true, variant:'success' })
        });
      }
    }
  }
  </script>
  